import React from "react";
import DxfGridComponent from "components/dxf-grid/dxf-grid.component";
import ActionsPanelComponent, { PanelItem } from "components/dxf-grid/actions-panel.component";
import { useModal } from "hooks";
import { formatDate, json, withDateFilter } from "helpers/data";
import ChangeDevice from "../component/changeDevice";
import { t } from "i18next";
import { appLicensesSourceAtom } from "./lincenses.store";
import { useParams } from "react-router-dom";
import { useUnmount } from "react-use";
import { useRecoilValue } from "recoil";
import InProgress from "assets/images/svg/in_progress.svg";
import Generated from "assets/images/svg/download_lic.svg";
import Expired from "assets/images/svg/renew_green.svg";
import PreviewImage from "components/preview-img";
import _productService from "services/products-services";
import { useStatus } from "hooks/use-status";
import { toast } from "react-toastify";
import CanLoadGuard from "components/private-route/can-load.guard";
import AlertBox from "components/popup/alert";
import useAlert from "hooks/useAlert";

const LicensesPage = () => {
  const { id } = useParams();
  const { done, stop } = useStatus();

  const appLicensesSource = useRecoilValue(appLicensesSourceAtom(id!));
  useUnmount(() => appLicensesSource.filter([]));

  const success = () => {
    done();
    appLicensesSource.reload();
    toast.success(t("common:form.renew") as string);
  };

  const handleRenew = async (licenseId: any) => {
    const renewData = {
      versionSubscriptionId: id,
      licenseId: licenseId
    };
    const { response, error } = await _productService.renewActivationLicense(renewData);
    if (response) success();
    if (error) stop();
  };

  const getIconRow = (status: any, id: any, file: any) => {
    switch (status) {
      case 1:
        return <PreviewImage src={InProgress} alt="back" />;
      case 2:
        return (
          <PreviewImage
            src={Generated}
            alt="back"
            onClick={() => {
              const link = document.createElement("a");
              link.download = file?.realName;
              link.target = "_blank";
              link.href = `${file?.fullPath}?sv=2021-04-10&st=2023-04-01T10%3A48%3A00Z&se=2027-12-31T10%3A48%3A00Z&sr=c&sp=rl&sig=Lxf%2F3jilYy360Qa02r9grLAaRfQNM7YVRw8e9sgvb5I%3D`;
              link.click();
            }}
          />
        );
      case 3:
        return <PreviewImage src={Expired} alt="back" onClick={() => handleRenew(id)} />;
    }
  };

  return (
    <div className="licensesPage">
      <div className="dataTable">
        <DxfGridComponent
          dataSource={appLicensesSource}
          columns={[
            {
              id: "deviceName",
              width: "200",
              caption: "browse-apps:myProducts.productLicense.deviceCol",
              calculateCellValue: (data: any) => data.deviceName
            },
            {
              id: "Serial",
              caption: "browse-apps:myProducts.productLicense.serialcol",
              calculateCellValue: (data: any) => data.serialNumber
            },
            {
              dataType: "date",
              id: "ActivateOn",
              width: "200",
              caption: "browse-apps:myProducts.productLicense.activeCol",
              calculateDisplayValue: (data: any) => (data.activatedOn ? formatDate(data.activatedOn) : ""),
              calculateFilterExpression: withDateFilter("ActivateOn")
            },
            {
              dataType: "date",
              id: "RenewalDate",
              caption: "browse-apps:myProducts.productLicense.renewalCol",
              calculateDisplayValue: (data: any) => formatDate(data.renwalDate),
              calculateFilterExpression: withDateFilter("RenewalDate")
            },

            {
              id: "LicenseStatus.Status",
              caption: "admin:tags.statusCol",
              calculateCellValue: (data: any) => json(data.status)
            },
            {
              id: "",
              width: "60",
              cellRender: (data: any) => (
                <CanLoadGuard>{getIconRow(data.data.statusId, data.data.id, data.data.file)}</CanLoadGuard>
              )
            }
          ]}
          actionsElement={({ data }: any) => (
            <CanLoadGuard>
              <LicenseActions data={data} />
            </CanLoadGuard>
          )}
        ></DxfGridComponent>
      </div>
    </div>
  );
};

const LicenseActions: React.FC<any> = ({ data }) => {
  const [showChangeDevice, openChangeDevice, closeChangeDevice] = useModal(false);
  const [showAlert, openAlertModal, closeAlertModal] = useAlert(false);

  const actions: PanelItem[] = [
    {
      label: t("browse-apps:myProducts.productLicense.changeDevice"),
      action: data?.hasRelatedAddonLicense ? openAlertModal : openChangeDevice
    }
  ];
  return (
    <>
      {data?.statusId === 2 && <ActionsPanelComponent actions={actions} />}
      <ChangeDevice show={showChangeDevice} onHide={closeChangeDevice} device={data} />
      <AlertBox
        show={showAlert}
        onHide={closeAlertModal}
        onOk={() => {
          closeAlertModal();
          openChangeDevice();
        }}
        Msg="changeDeviceMsg"
      />
    </>
  );
};

export default LicensesPage;
